import { lazy } from "react";
import AuthGuard from "routes/AuthGuard";
import Loadable from "routes/Loadable";
import AdminLayout from "components/layouts/adminLayout";
import ProjectLayout from "components/layouts/projectLayout";
import ProjectDetails from "pages/project/Details";

//project
const ProjectList = Loadable(lazy(() => import("pages/project")));
const AddProject = Loadable(lazy(() => import("pages/project/Add")));
const ProjectExpenseUnit = Loadable(lazy(() => import("pages/project/expense/ProjectExpenseUnit")));

//--buyer
const ProjectBuyer = Loadable(lazy(() => import("pages/project/buyer")));
const LandSelling = Loadable(lazy(() => import("pages/project/buyer/LandSelling")));
const LandSellingPayment = Loadable(lazy(() => import("pages/project/buyer/LandSellingPayment")));
const LandSellingPaymentReceipt = Loadable(lazy(() => import("pages/project/buyer/LandSellingPaymentReceipt")));
const DueReport = Loadable(lazy(() => import("pages/project/buyer/DueReport")));
const PayOrder = Loadable(lazy(() => import("pages/project/buyer/PayOrder")));
const DuePay = Loadable(lazy(() => import("pages/project/buyer/DuePay")));
const DuePayReceipt = Loadable(lazy(() => import("pages/project/buyer/DuePayReceipt")));
const FlatSelling = Loadable(lazy(() => import("pages/project/buyer/FlatSelling")));
const FlatSellingAdjustment = Loadable(lazy(() => import("pages/project/buyer/FlatSellingAdjustmentPayment")));

//--land expense
const LandExpenseCategory = Loadable(lazy(() => import("pages/project/land-expense/LandExpenseCategory")));
const LandExpense = Loadable(lazy(() => import("pages/project/land-expense/LandExpense")));
const ReportExpenseCategory = Loadable(lazy(() => import("pages/project/expense/ReportExpenseCategory")));
const ProjectExpenseCategory = Loadable(lazy(() => import("pages/project/expense/ProjectExpenseCategory")));

//--project expense
const ProjectExpense = Loadable(lazy(() => import("pages/project/expense/expense")));
const ProjectExpensePay = Loadable(lazy(() => import("pages/project/expense/expense/PayExpense")));
const AddProjectExpense = Loadable(lazy(() => import("pages/project/expense/AddProjectExpense")));
const ProjectExpenseVault = Loadable(lazy(() => import("pages/project/expense/Vault")));
const ProjectExpenseVaultDistribution = Loadable(lazy(() => import("pages/project/expense/VaultDistribution")));

const ConstructionCharge = Loadable(lazy(() => import("pages/project/construction-charge")));
const IncomeAndExpenseReport = Loadable(lazy(() => import("pages/project/report/IncomeAndExpense")));

const ProjectRoutes = {
  path: "project",
  element: (
    <AuthGuard>
      <AdminLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "list",
      element: <ProjectList />,
    },
    {
      path: "add",
      element: <AddProject />,
    },
    {
      path: "expense-unit",
      element: <ProjectExpenseUnit />,
    },
    {
      path: "land/expense-category",
      element: <LandExpenseCategory />,
    },
    {
      path: "report-expense-category",
      element: <ReportExpenseCategory />,
    },
    {
      path: "expense-category",
      element: <ProjectExpenseCategory />,
    },

    //project/:projectId
    {
      path: ":projectId",
      element: <ProjectLayout />,
      children: [
        {
          path: "details",
          element: <ProjectDetails />,
        },
        {
          path: "buyer",
          element: <ProjectBuyer />,
        },
        {
          path: "buyer/:personId/pay-order",
          element: <PayOrder />,
        },
        {
          path: "buyer/:personId/due-pay",
          element: <DuePay />,
        },
        {
          path: "buyer/:personId/due-pay/receipt/:id",
          element: <DuePayReceipt />,
        },
        {
          path: "buyer/:personId/flat/selling",
          element: <FlatSelling />,
        },
        {
          path: "buyer/:personId/flat/selling/adjustment",
          element: <FlatSellingAdjustment />,
        },
        {
          path: "buyer/:personId/land/selling",
          element: <LandSelling />,
        },
        {
          path: "buyer/:personId/land/selling/payment",
          element: <LandSellingPayment />,
        },
        {
          path: "buyer/:personId/land/selling/payment-receipt/:id",
          element: <LandSellingPaymentReceipt />,
        },
        {
          path: "buyer/:personId/report/due",
          element: <DueReport />,
        },
        {
          path: "construction-charge",
          element: <ConstructionCharge />,
        },
        {
          path: "land/expense",
          element: <LandExpense />,
        },
        {
          path: "expense",
          element: <ProjectExpense />,
        },
        {
          path: "expense/pay/:expenseId",
          element: <ProjectExpensePay />,
        },
        {
          path: "expense/add",
          element: <AddProjectExpense />,
        },
        {
          path: "expense/vault",
          element: <ProjectExpenseVault />,
        },
        {
          path: "expense/vault/:vaultId",
          element: <ProjectExpenseVaultDistribution />,
        },
        {
          path: "report/income-expense",
          element: <IncomeAndExpenseReport />,
        },
      ],
    },
  ],
};

export default ProjectRoutes;
